export const AIRCRAFT_PORTFOLIO_STATS = "AIRCRAFT_PORTFOLIO/STATS";
export const AIRCRAFT_PORTFOLIO_STATS_PENDING = "AIRCRAFT_PORTFOLIO/STATS_PENDING";
export const AIRCRAFT_PORTFOLIO_STATS_FULFILLED = "AIRCRAFT_PORTFOLIO/STATS_FULFILLED";

export const AIRCRAFT_PORTFOLIO_VALUES = "AIRCRAFT_PORTFOLIO/VALUES";
export const AIRCRAFT_PORTFOLIO_VALUES_PENDING = "AIRCRAFT_PORTFOLIO/VALUES_PENDING";
export const AIRCRAFT_PORTFOLIO_VALUES_FULFILLED = "AIRCRAFT_PORTFOLIO/VALUES_FULFILLED";
